import ReactGA from 'react-ga4';
import * as FullStory from '@fullstory/browser';
import { isEmpty } from 'lodash-es';

const toArray = trackers => (trackers instanceof Array ? trackers : [trackers]);
export class Tracker {
  constructor(tracker) {
    if (!this.checkoutFlowStart) {
      this.checkoutFlowStart = new Date();
    }

    this.fireEvent = (gaData = {}, fsData = {}) => {
      if (!isEmpty(gaData)) {
        if (gaData.value) {
          gaData.value = { value: gaData.value };
        }

        ReactGA.event(gaData, toArray(tracker));
      }

      // eslint-disable-next-line
      if (window?._fs_initialized && !isEmpty(fsData)) {
        const { category, ...rest } = fsData;
        FullStory.event(category, rest);
      }
    };
  }
}
